import React, { useEffect, useState } from "react";
import { Card, Upload, Image, Space, Typography } from "antd";
import { UploadOutlined } from "@ant-design/icons";
import classes from "../AddBanner.module.scss";

const MediaUploadCard = ({ text, icon: Icon, onChange, value }) => {
  // controla se o preview está aberto
  const [previewOpen, setPreviewOpen] = useState(false);

  // imagem que vai aparecer no preview
  const [previewImage, setPreviewImage] = useState("");

  // lista de arquivos enviados
  const [fileList, setFileList] = useState(value ? [value] : []);

  useEffect(() => {
    setFileList(value ? [value] : []);
  }, [value]);

  // quando clica na imagem
  const handlePreview = async (file) => {
    // pega a imagem (url original ou miniatura)
    setPreviewImage(file.url || file.thumbUrl);
    // abre o modal de preview
    setPreviewOpen(true);
  };

  // quando adiciona/remove arquivo de imagem
  const handleChange = ({ fileList: newFileList }) => {
    // atualiza a lista de arquivos no estado
    setFileList(newFileList);
    // se existir função vinda do componente pai
    if (onChange) {
      const fileToUpload = newFileList?.[0]?.originFileObj || null;

      // envia o primeiro arquivo (ou null se não tiver nenhum)
      onChange(fileToUpload);
    }
  };

  const uploadButton = (
    <div style={{ border: 0, background: "none" }} type="button">
      <UploadOutlined style={{ fontSize: "20px", color: "#6A7181" }} />
      <div style={{ marginTop: "10px" }}>
        <p style={{ fontSize: "11px", color: "#6A7181" }}>Clique para enviar</p>
        <p style={{ fontSize: "11px", color: "#6A7181" }}>PNG, JPG até 5MB</p>
      </div>
    </div>
  );

  return (
    <Card className={classes.uploadCard} style={{ width: "235px" }}>
      <Space style={{ marginBottom: "10px" }}>
        {Icon && <Icon />}
        <Typography
          style={{ fontSize: "13px", fontWeight: 500, color: "#3A3D43" }}
        >
          {text}
        </Typography>
      </Space>

      <Upload
        beforeUpload={() => false} // Não enviar automaticamente
        listType="picture-card"
        fileList={fileList}
        onPreview={handlePreview}
        onChange={handleChange}
      >
        {fileList.length === 1 ? null : uploadButton}
      </Upload>
      {previewImage && (
        <Image
          wrapperStyle={{ display: "none" }}
          preview={{
            visible: previewOpen,
            onVisibleChange: (visible) => setPreviewOpen(visible),
            afterOpenChange: (visible) => !visible && setPreviewImage(""),
          }}
          src={previewImage}
        />
      )}
    </Card>
  );
};

export default MediaUploadCard;
